/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionDocumentType = {
  type: 'Enum',
} as const;
